import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { signOut } from 'firebase/auth';
import { auth } from '../firebase';
import './Dashboard.css';

function Dashboard() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const handleLogout = async () => {
    try {
      await signOut(auth);
    } catch (error) {
      console.error('Error logging out:', error);
    }
  };

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const menuItems = [
    {
      title: 'Users',
      description: 'View and manage all registered mobile app users',
      icon: '👥',
      link: '/users',
      color: '#FF1493',
    },
    {
      title: 'Notifications',
      description: 'Send push notifications to mobile app users',
      icon: '🔔',
      link: '/notifications',
      color: '#FF5722',
    },
    {
      title: 'Home Slides',
      description: 'Manage slider images and content on the home screen',
      icon: '🖼️',
      link: '/home-slides',
      color: '#FF6B9D',
    },
    {
      title: 'Photo Gallery',
      description: 'Manage photo gallery images displayed on home screen',
      icon: '📷',
      link: '/photo-slides',
      color: '#FF4081',
    },
    {
      title: 'Women Initiatives',
      description: 'Manage central and state government women initiatives',
      icon: '🏛️',
      link: '/women-initiatives',
      color: '#E91E63',
    },
    {
      title: 'Awareness Images',
      description: 'Manage awareness posters displayed in the app',
      icon: '🖼️',
      link: '/awareness-images',
      color: '#FF4081',
    },
    {
      title: 'Awareness Videos',
      description: 'Manage educational YouTube videos for awareness',
      icon: '🎥',
      link: '/awareness-videos',
      color: '#F50057',
    },
    {
      title: 'Campaigns',
      description: 'Manage campaigns and awareness programs',
      icon: '📢',
      link: '/campaigns',
      color: '#FF69B4',
    },
    {
      title: 'Schemes',
      description: 'Manage government schemes and benefits',
      icon: '🎁',
      link: '/schemes',
      color: '#E91E63',
    },
    {
      title: 'Inspirational Women',
      description: 'Manage profiles of inspirational women role models',
      icon: '👩',
      link: '/inspirational-women',
      color: '#C2185B',
    },
    {
      title: 'Feedbacks',
      description: 'View and manage user feedback submissions',
      icon: '💬',
      link: '/feedbacks',
      color: '#9C27B0',
    },
  ];

  return (
    <div>
      <header className="header">
        <div className="header-content">
          <h1>Beti Bachao Beti Padhao - Admin Panel</h1>

          <button
            className="mobile-menu-btn"
            onClick={toggleMobileMenu}
            aria-label="Toggle menu"
          >
            {mobileMenuOpen ? '✕' : '☰'}
          </button>

          <div className={`nav-links ${mobileMenuOpen ? 'mobile-open' : ''}`}>
            <span style={{ color: 'white', fontWeight: '500' }}>Welcome, Admin</span>
            <button onClick={handleLogout} className="logout-btn">
              Logout
            </button>
          </div>
        </div>
      </header>

      <div className="container">
        <div className="dashboard-welcome">
          <h2>Welcome to the Admin Dashboard</h2>
          <p>Manage all content for the Beti Bachao Beti Padhao mobile application</p>
        </div>

        <div className="dashboard-grid">
          {menuItems.map((item, index) => (
            <Link key={index} to={item.link} className="dashboard-card" style={{ borderTopColor: item.color }}>
              <div className="card-icon">{item.icon}</div>
              <h3>{item.title}</h3>
              <p>{item.description}</p>
              <span className="card-link" style={{ color: item.color }}>
                Manage →
              </span>
            </Link>
          ))}
        </div>

        <div className="dashboard-info">
          <h3>Important Notes</h3>
          <ul>
            <li>All changes made here will be immediately reflected in the mobile app</li>
            <li>Make sure to fill in all required fields when adding or editing content</li>
            <li>Use the "order" field to control the sequence of items</li>
            <li>Always test changes on the mobile app before deploying to production</li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default Dashboard;
